<template>
  <div>
    <!-- 底标 -->
    <van-divider>我是有底线哒</van-divider>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
.van-divider::before,
.van-divider::after {
  border-color: #bbbbbb;
  margin-right: 20px;
  margin-left: 20px;
}
</style>
